import { FlexContainer, palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

const ToolbarItemStyled = styled(FlexContainer)((props) => {
  return {
    width: '100%',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:not(:last-of-type)': {
      borderRight: `1px solid ${palette.black.plus70}`,
    },
  }
})

export default ToolbarItemStyled
